import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import Radios from './Radios';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getMemberinfo } from '../utils/utils';
import * as APIS from "../utils/service";
import moment from 'moment';

export default function ProductOutSimplewrite(props) {

    const {
        setsimplewrite = () => { },
        setselltypeproduct = () => { },
        setcategory_1product = () => { },
        setcategory_2product = () => { },
        row = {},
    } = props;

    const { configdata } = useSelector(s => s.configReducer);
    const selectFile = useRef(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchactive, setsearchactive] = useState(0);
    const [searchvar, setsearchvar] = useState(0);
    const [sell_type, setsell_type] = useState('매매');

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx, category_1: x?.category_1 }
    })
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);
    const [easy, seteasy] = useState(true);
    const [errmsg, seterrmsg] = useState('');
    const [memberinfos, setmemberinfos] = useState('');


    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(firstCategorys);
    const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx);
    const [isOpenPost, setIsOpenPost] = useState(false);

    const [addrDatas, setaddrDatas] = useState({});

    const [building_dong, setbuilding_dong] = useState(''); //해당동
    const [building_floor, setbuilding_floor] = useState(''); //해당층
    const [building_unit, setbuilding_unit] = useState(''); //해당호

    const [price_sell, setprice_sell] = useState(''); //매매가
    const [now_price_all, setnow_price_all] = useState(''); //현보증금
    const [now_price_month, setnow_price_month] = useState(''); //현재월세
    const [price_all, setprice_all] = useState(''); //보증금
    const [price_month, setprice_month] = useState(''); //현재월세
    const [price_keymoney, setprice_keymoney] = useState(''); //권리금
    const [price_maintenance, setprice_maintenance] = useState(''); //관리비
    const [pricesinputArr, setpricesinputArr] = useState([
        { key: 'price_sell', default: true, inputstyle: 0, titles: '매매가', values: price_sell, setvaluesfunc: setprice_sell, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { key: 'now_price_all', default: false, inputstyle: 0, titles: '현보증금', values: now_price_all, setvaluesfunc: setnow_price_all, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { key: 'now_price_month', default: false, inputstyle: 0, titles: '현재월세', values: now_price_month, setvaluesfunc: setnow_price_month, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { key: 'price_all', default: true, inputstyle: 0, titles: '보증금', values: price_all, setvaluesfunc: setprice_all, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['전세', '월세'] },
        { key: 'price_month', default: true, inputstyle: 0, titles: '월세', values: price_month, setvaluesfunc: setprice_month, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['월세'] },
        { key: 'price_keymoney', default: false, inputstyle: 0, titles: '권리금', values: price_keymoney, setvaluesfunc: setprice_keymoney, input_type: 'number', viewtype: [2, 3], viewtype2: ['매매', '전세', '월세'] },
        { key: 'price_maintenance', default: true, inputstyle: 0, titles: '관리비', values: price_maintenance, setvaluesfunc: setprice_maintenance, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매', '전세', '월세'] },
    ]);
    const [area_supply, setarea_supply] = useState(''); //공급면적
    const [area_contract, setarea_contract] = useState(''); //계약면적
    const [area_private, setarea_private] = useState(''); //전용면적

    const [building_count, setbuilding_count] = useState(''); //건물 수	
    const [building_floor_all, setbuilding_floor_all] = useState(''); //지상 총 층	
    const [building_floor_under_all, setbuilding_floor_under_all] = useState(''); //지하 총 층	
    const [area_land, setarea_land] = useState(''); //토지면적
    const [area_floor, setarea_floor] = useState(''); //연면적
    const [client_name, setclient_name] = useState(''); //의뢰인
    const [client_hp, setclient_hp] = useState(''); //연락처
    const [desc, setdesc] = useState(''); //특이사항

    const [files, setfiles] = useState([]);


    useEffect(() => {
        dispatch(loadingflas({ loading: false }));
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        if (row?.idx) {
            console.log(row);
            setsell_type(row?.sell_type);
            setcategory_1(row?.category_1);
            setcategory_2(row?.category_2);

            setbuilding_dong(row?.building_dong);
            setbuilding_floor(row?.building_floor);
            setbuilding_unit(row?.building_unit);

            setaddrDatas({
                addr: row?.addr,
                sido: row?.sido,
                sigungu: row?.sigungu || row?.sido,
                dong: row?.dong || row?.dong
            });

            pricesinputArr?.map((x, i) => {
                setpricesinputArr(pricesinputArr?.map((x2, i2) => {
                    x2?.setvaluesfunc(row[x2?.key]);
                    return { ...x2, values: row[x2?.key] };
                }));
            })
            setarea_supply(row?.area_supply);
            setarea_contract(row?.area_contract);
            setarea_private(row?.area_private);
            setbuilding_count(row?.building_count);
            setbuilding_floor_all(row?.building_floor_all);
            setbuilding_floor_under_all(row?.building_floor_under_all);
            setarea_land(row?.area_land);
            setarea_floor(row?.area_floor);

            setclient_name(row?.client_name);
            setclient_hp(row?.client_hp);
            setdesc(row?.desc);
        }
    }, [row]);

    useEffect(() => {
        seterrmsg('');
    }, [
        sell_type, category_1, category_2, addrDatas, building_dong, building_floor, building_unit,
        price_sell, now_price_all, now_price_month, price_all, price_month, price_keymoney, price_maintenance, price_maintenance,
        area_supply, area_contract, area_private, building_count, building_floor_all, building_floor_under_all, area_land, area_floor,
        client_name, client_hp, desc, files
    ]);

    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);

        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        console.log(data);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido,
            dong: data?.bname1 || data?.bname
        });

        setIsOpenPost(false);
    };
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    const simpleWirteSubmit = (uidx = null, removed = false) => {

        // sell_type, category_1, category_2, addrDatas, building_dong, building_floor, building_unit,
        // price_sell, now_price_all, now_price_month, price_all, price_month, price_keymoney, price_maintenance, price_maintenance,
        // area_supply, area_contract, area_private, building_count, building_floor_all, building_floor_under_all, area_land, area_floor,
        // client_name, client_hp
        //console.log("addrDatas", addrDatas);
        let inputsdefaultsArr = [
            { values: sell_type, comments: '거래형태를', comment_types: '선택' },
            { values: category_1, comments: '매물종류를', comment_types: '선택' },
            { values: category_2, comments: '하위매물종류를', comment_types: '선택' },
            { values: addrDatas?.sido || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.sigungu || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.dong || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.addr || '', comments: '소재지를', comment_types: '검색' },
            sell_type === '매매' && { values: price_sell, comments: '매매가를', comment_types: '입력' },
            (sell_type === '전세' || sell_type === '월세') && { values: price_all, comments: '보증금을', comment_types: '입력' },
            (sell_type === '월세') && { values: price_month, comments: '월세를', comment_types: '입력' },
            { values: price_maintenance, comments: '관리비 를', comment_types: '입력' },
            { values: client_name, comments: '의뢰인을', comment_types: '입력' },
            { values: client_hp, comments: '연락처를', comment_types: '입력' },
        ];
        //console.log('???', building_floor_under_all);
        for (let c = 0; c < inputsdefaultsArr?.length; c++) {
            if (inputsdefaultsArr[c]?.values === '') {
                seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
                return;
            }
        }

        let fileSetting = [];
        files?.map((x, i) => {
            fileSetting.push({ base: x?.base64, ext: x?.ext });
        });

        let sender = {
            idx: uidx,
            miniIdx: row?.idx,
            easy: easy,
            sell_type: sell_type,
            title: '',
            category_1: category_1,
            category_2: category_2,
            sido: addrDatas?.sido,
            sigungu: addrDatas?.sigungu,
            dong: addrDatas?.dong,
            addr: addrDatas?.addr,
            price_sell: price_sell * 1,
            now_price_all: now_price_all * 1,
            now_price_month: now_price_month * 1,
            price_all: price_all * 1,
            price_month: price_month * 1,
            price_keymoney: price_keymoney * 1,
            price_maintenance: price_maintenance * 1,
            area_supply: area_supply,
            area_contract: area_contract,
            area_private: area_private,
            area_land: area_land,
            area_floor: area_floor,
            building_dong: building_dong,
            //building_dong_floor_all: building_dong_floor_all,
            building_floor: building_floor,
            building_unit: building_unit,
            building_count: building_count,
            building_floor_all: building_floor_all,
            building_floor_under_all: building_floor_under_all,
            //building_unit_all: building_unit_all,
            //building_unit_empty: building_unit_empty,
            //item_direction: item_direction,
            //item_direction_standard: item_direction_standard,
            //item_room: item_room,
            //item_bathroom: item_bathroom,
            //item_households: item_households,
            //item_car_all: item_car_all,
            //item_car: item_car,
            //item_elevator: item_elevator,
            //item_usage: item_usage,
            //item_date_type: item_date_type,
            //item_date: item_date,
            //item_move_date: item_move_date,
            client_name: client_name,
            client_hp: client_hp,
            desc: desc,
            files: [],
            delete_files: [],
        }
        //console.log(sender);
        //return;

        dispatch(
            open({
                component: '등록하시겠습니까?',
                title: '알림',
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    APIS.postData('/v1/item/insert', sender).then(({ data }) => {
                        if (data) {
                            dispatch(close());
                            setsimplewrite(false);
                            dispatch(listupdater({ listupdate: true }));

                            dispatch(
                                open({
                                    component: '매물이 등록되었습니다.',
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        setselltypeproduct(sell_type);
                                        setcategory_1product(category_1 * 1);
                                        setcategory_2product(category_2 * 1);
                                        dispatch(close());
                                    }
                                })
                            );

                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        console.log(response);
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );


    }

    const messagePopup = (msg) => {
        dispatch(
            open({
                component: msg,
                title: '알림',
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    return (
        <>
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setsimplewrite(false);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop">
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee' }}>
                            <span>간편등록</span>
                            <button
                                onClick={() => {
                                    setsimplewrite(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />
                            </button>
                        </div>
                        <div className="productInputarea padding32" >
                            <div className='fontsize12' style={{ marginBottom: 8 }}>
                                필수표시사항(<span className='colorF00'>*</span>)을 정확하게 입력해주세요.
                            </div>
                            <div className="inputviewtype1 ">
                                <div>거래형태<span className='colorF00'>*</span></div>
                                <div>
                                    {category_2 * 1 !== 3 &&
                                        <Button buttonTxt={'매매'} className={`writeRadiobutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => {
                                            // if(category_2*1 === 3){
                                            //     setcategory_2(1) 
                                            //     //return;
                                            // }
                                            setsell_type('매매')
                                        }} />}
                                    <Button buttonTxt={'전세'} className={`writeRadiobutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => setsell_type('전세')} />
                                    <Button buttonTxt={'월세'} className={`writeRadiobutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => setsell_type('월세')} />
                                </div>

                            </div>
                            {category_2 * 1 === 3 &&
                                <div className="input_error">* 단독/다가구 매매는 건물-주거전용건물 탭을 이용하세요.</div>
                            }
                            <div className="inputviewtype1 ">
                                <div>매물종류<span className='colorF00'>*</span></div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div style={{ width: 'calc(50% - 2px)' }}>
                                        <Select
                                            styles={{}}
                                            setValues={(cate1) => {
                                                setcategory_1(cate1)
                                                setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === cate1 * 1))[0]?.values);
                                            }}
                                            values={category_1}
                                            selectData={category_1_OptionConsts}
                                        />
                                    </div>

                                    <div style={{ width: 'calc(50% - 2px)' }}>
                                        <Select
                                            styles={{}}
                                            setValues={(e) => {
                                                if (sell_type === '매매' && e * 1 === 3) {
                                                    setsell_type('전세');
                                                }
                                                setcategory_2(e);
                                            }}
                                            values={category_2}
                                            selectData={category_2_setting?.filter((x, i) => x?.category_1 * 1 === category_1 * 1)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="inputviewtype1 ">
                                <div>소재지<span className='colorF00'>*</span></div>
                                <div>
                                    <div className='buttonWithTxt' style={{ marginTop: 8 }}>
                                        <div>
                                            <Button
                                                className={'normalbutton_middle'}
                                                buttonTxt={'주소찾기'}
                                                onPress={() => {
                                                    setIsOpenPost(true);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            {addrDatas?.addr}
                                        </div>
                                    </div>
                                    {isOpenPost ? (
                                        <div style={postBoxStyle}>
                                            <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999" />
                                                </svg>
                                            </button>
                                            <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {category_1 * 1 !== 3 &&
                                <div className="inputviewtype2 ">
                                    <div>세부정보</div>
                                    <div>
                                        <div>
                                            <div>

                                                <span>동</span>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="동"
                                                    setValue={setbuilding_dong}
                                                    value={building_dong}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 30, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <span>층</span>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="층"
                                                    setValue={setbuilding_floor}
                                                    value={building_floor}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 30, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <span>호</span>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="호"
                                                    setValue={setbuilding_unit}
                                                    value={building_unit}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 30, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>복수인 경우 콤마(,)로 구분</div>
                                    </div>
                                </div>
                            }


                            {pricesinputArr?.map((x, i) => {
                                if (!x?.viewtype?.find((x) => x * 1 === category_1 * 1)) {
                                    return;
                                }
                                if (!x?.viewtype2?.find((x) => x === sell_type)) {
                                    return;
                                }
                                if (x?.titles === '권리금' && category_1 * 1 === 3 && category_2 * 1 !== 9) {
                                    return;
                                }

                                return (
                                    <div className="inputviewtype1 " key={i}>
                                        <div>{x?.titles}{x?.default === true && <span className='colorF00'>*</span>}</div>
                                        <div>
                                            <Input
                                                type={x?.input_type}
                                                className={`inputs`}
                                                rightplaceholder="만원"
                                                placeholder=""
                                                setValue={(e) => {
                                                    x?.setvaluesfunc(e);
                                                    setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                }}
                                                value={x?.values}
                                                name={x?.titles}
                                                zerostatus={true}
                                                style={{
                                                    paddingRight: 40, textAlign: 'right'
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}

                            {category_1 * 1 !== 3 &&
                                <div className="inputviewtype3 ">
                                    {(category_2 * 1 === 1 || category_2 * 1 === 2 || category_2 * 1 === 3) ?
                                        <div>
                                            <div>공급</div>
                                            <div>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="㎡"
                                                    placeholder=""
                                                    setValue={setarea_supply}
                                                    value={area_supply}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 32, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <div>계약</div>
                                            <div>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="㎡"
                                                    placeholder=""
                                                    setValue={setarea_contract}
                                                    value={area_contract}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 32, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    }

                                    <div>
                                        <div style={{ textAlign: 'right' }}>전용</div>
                                        <div>
                                            <Input
                                                className={`inputs`}
                                                rightplaceholder="㎡"
                                                placeholder=""
                                                setValue={setarea_private}
                                                value={area_private}
                                                name="mb_phone"
                                                zerostatus={true}
                                                style={{
                                                    paddingRight: 32, textAlign: 'right'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }


                            {category_1 * 1 === 3 &&
                                <>
                                    <div className="inputviewtype2 ">
                                        <div>건물정보<span className='colorF00'>*</span></div>
                                        <div>
                                            <div>
                                                <div>
                                                    <Input
                                                        className={`inputs`}
                                                        leftplaceholder="건물수"
                                                        setValue={setbuilding_count}
                                                        value={building_count}
                                                        name="mb_phone"
                                                        zerostatus={true}
                                                        style={{
                                                            paddingLeft: 0, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <Input
                                                        className={`inputs`}
                                                        leftplaceholder="지상총층"
                                                        setValue={setbuilding_floor_all}
                                                        value={building_floor_all}
                                                        name="mb_phone"
                                                        zerostatus={true}
                                                        style={{
                                                            paddingLeft: 0, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <Input
                                                        className={`inputs`}
                                                        leftplaceholder="지하총층"
                                                        setValue={setbuilding_floor_under_all}
                                                        value={building_floor_under_all}
                                                        name="mb_phone"
                                                        zerostatus={true}
                                                        style={{
                                                            paddingLeft: 0, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inputviewtype3 ">
                                        <div>
                                            <div>토지면적<span className='colorF00'>*</span></div>
                                            <div>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="㎡"
                                                    placeholder=""
                                                    setValue={setarea_land}
                                                    value={area_land}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 32, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ textAlign: 'right' }}>연면적<span className='colorF00'>*</span></div>
                                            <div>
                                                <Input
                                                    className={`inputs`}
                                                    rightplaceholder="㎡"
                                                    placeholder=""
                                                    setValue={setarea_floor}
                                                    value={area_floor}
                                                    name="mb_phone"
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 32, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            <div className="inputviewtype3 ">
                                <div>
                                    <div>의뢰인<span className='colorF00'>*</span></div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={setclient_name}
                                            value={client_name}
                                            name="mb_phone"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div style={{ textAlign: 'right' }}>연락처<span className='colorF00'>*</span></div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={setclient_hp}
                                            value={client_hp}
                                            name="customerhp"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                                let file = e.target.files[0];
                                getBase64(file).then(result => {
                                    file["base64"] = result;
                                    file["ext"] = file.name.split('.')[1];
                                    //console.log("File Is", file);
                                    setfiles([...files, file]);
                                })
                                .catch(err => { console.log(err); });
                            }} />
                                                        
                            <div className="inputviewtype1 ">
                                <div>사진</div>
                                <div>
                                    <div className="write_image_list">
                                        {files?.length < 3 &&
                                        <button 
                                            type="button"
                                            onClick={() => {
                                                selectFile.current.click();
                                            }}
                                        >
                                            <p>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                                            </svg>             
                                            </p>
                                            <p>업로드</p>
                                            <p>{files?.length}<span className='color999'>/3</span></p>
                                        </button>
                                        }
                                                                                
                                        {files?.map((x, i) => {
                                            return (
                                                <div key={i} style={{ backgroundImage: `url(${x?.base64})`}}>
                                                    <button 
                                                        type="button"
                                                        onClick={() => {
                                                            seterrmsg('');
                                                            setfiles(files?.filter((x2, i2) => i2 !== i));
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                            <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                                        </svg>                
                                                    </button>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            </div>    */}
                            <div className="inputviewtype1 ">
                                <div>특이사항</div>
                                <div>
                                    <textarea
                                        placeholder='추후 상세등록 시 필요한 사항들을 작성하시면 매물관리에 도움이 됩니다.ex) 방/욕실 수, 공실여부, 현업종, 상호 등'
                                        onChange={(e) => {
                                            setdesc(e.target.value);
                                        }}
                                        value={desc}
                                    />
                                </div>
                            </div>
                            <div
                                style={{ height: 1, backgroundColor: '#EEE', marginTop: 20 }}
                            />
                            <div style={{ textAlign: 'center', marginTop: 20 }}>간편등록은 특별 기능을 이용하실 수 없습니다.</div>
                            <div style={{ textAlign: 'center' }}>간편등록 이후 시간이 날 때 반드시 상세 등록을 진행해 주세요.</div>
                            <div className="input_error">{errmsg}</div>
                            <div
                                className='margint20'
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                }}
                            >
                                <div style={{ width: '50%' }}>
                                    <Button
                                        buttonTxt={'취소'}
                                        disabled={true}
                                        onPress={() => {
                                            setsimplewrite(false);
                                        }}
                                    />
                                </div>
                                <div style={{ width: '50%' }}>
                                    <Button
                                        buttonTxt={'등록'}
                                        styles={{
                                        }}
                                        onPress={() => {
                                            simpleWirteSubmit();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )
}